/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: auth-slice.ts
 * Project: mle-client
 * Committed last: 2021/11/7 @ 1332
 * ---
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AbstractAuthEntity }         from '../../api/ap/auth-entities';
import {
  localLogin,
  logout,
  me,
  registerAndBoard
}                                     from '../actions/auth-actions';
import { User }                       from '../../entities';

interface AuthState extends AbstractAuthEntity {
  isLoggedIn: boolean;
  user: User;
}

const initialState = {
  isLoggedIn: false,
  _id: '',
  instanceId: '',
  email: '',
  currentRefreshToken: '',
  strategySpecificData: {},
  user: {}
} as AuthState;


const _authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setData: (state: any, action: PayloadAction<any>) => {
      Object.assign(state, { ...action.payload, isLoggedIn: true });
    },
    clear: state => {
      Object.assign(state, initialState);
    }
  },
  extraReducers: (builder) => {
    /* LOCAL_LOGIN */
    builder.addCase(localLogin.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        _authSlice.caseReducers.setData(state, action);
      });

    /* LOCAL_REGISTER */
    builder.addCase(registerAndBoard.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        _authSlice.caseReducers.setData(state, action);
      });

    /* ME */
    builder.addCase(me.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        _authSlice.caseReducers.setData(state, action);
      });

    builder.addCase(me.rejected,
      (state: AuthState) => {
        _authSlice.caseReducers.clear(state);
      });

    /* LOGOUT */
    builder.addCase(logout.fulfilled,
      (state: AuthState) => {
        _authSlice.caseReducers.clear(state);
      });
  }
});

export const { clear } = _authSlice.actions;
export const authSlice = _authSlice.reducer;
